// @flow

import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector, useDispatch } from 'react-redux';
import * as R from 'ramda';
import SPBackend from '../../services/SPBackend';
import { log } from '../../utils/jsUtils';
import MemberDrawer from '../MemberDrawer/index';
import BillingHeader from './BillingHeader';
import BillingContent from './BillingContent';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { createClasses } from '../../utils/stylesUtils';
import styles from './Styles/BillingHome.Style';
import { selectUser } from '../../reduxStore/modules/user/selectors';

type Props = {};

const BillingHome = (props: Props) => {
  const theme = useTheme();
  const classes = createClasses(styles, theme);

  // drawer state & controls
  const [mobileOpen, setMobileOpen] = useState(false);
  const usehandleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const user = useSelector(selectUser);

  return (
    <Box sx={classes.root}>
      <Helmet>
        <title>Neo | Billing</title>
      </Helmet>
      <BillingHeader
        mobileOpen={mobileOpen} 
        usehandleDrawerToggle={usehandleDrawerToggle}
      />
      <MemberDrawer 
        mobileOpen={mobileOpen} 
        usehandleDrawerToggle={usehandleDrawerToggle}
      />
      <BillingContent /> 
    </Box>
  );
};

export default BillingHome;